"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _ColorConstants = require("../utils/v2/ColorConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var instance;

var ThemeManager =
/*#__PURE__*/
function () {
  function ThemeManager() {
    _classCallCheck(this, ThemeManager);

    this.themeVars = null;
  }

  _createClass(ThemeManager, [{
    key: "initialize",
    value: function initialize(themeVars) {
      this.themeVars = themeVars;
    }
    /**
     * Merge new mapping to existing variables.
     *
     * @param {object} themeVars - new themeVars to be merged.
     */

  }, {
    key: "merge",
    value: function merge(themeVars) {
      this.themeVars = (0, _merge2.default)(this.themeVars, themeVars);
    }
    /**
     * Get theme variable value
     * @param {string} key - Theme variable key
     * @returns {string} - Theme variable value
     */

  }, {
    key: "getVar",
    value: function getVar(key) {
      if (!this.themeVars) {
        var vars = _objectSpread({
          classPrefix: _ColorConstants.variables.classPrefix
        }, _ColorConstants.colors, {}, _ColorConstants.chartCategorialColors, {}, _ColorConstants.chartLinearColors);

        this.initialize(vars);
      }

      return this.themeVars[key];
    }
    /**
     * Given a number return a color hash value from the 8 supported
     * categorial colors.  See http://nutanix.design/2.0/#Diagrams_Colors
     *
     * @param {number} index - positive number.  A number larger than 7 will wrap.
     *   For example 8 is the same color as index 0, and 9 is the color as index 1
     *   and so on.
     * @returns {string} - color hash value.
     */

  }, {
    key: "getChartCategorialColorsByIndex",
    value: function getChartCategorialColorsByIndex(index) {
      return (0, _ColorConstants.getChartCategorialColorsByIndex)(index);
    }
    /**
     * Return a color hash value based on the input index and metricLength
     *
     * @param {number} index - Which color to choose from the given length.
     * @param {number} metricLength - (1-8) To refer to which color linear
     *   metric to use.  See http://nutanix.design/2.0/#Diagrams_Colors.
     *   NOTE: Currently the maximum support metricLenght is 8.
     * @return {string} - color hash
     */

  }, {
    key: "getChartLinearColorByIndex",
    value: function getChartLinearColorByIndex(index, metricLength) {
      return (0, _ColorConstants.getChartLinearColorByIndex)(index, metricLength);
    }
  }]);

  return ThemeManager;
}();

var _default = instance || (instance = new ThemeManager());

exports.default = _default;